import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { fetchTeacherListings } from 'actions/Teacher/listingActions';

import ListingBox from './ListingBox';

import './style.css';

class TeacherScheduleListingHome extends Component {
  componentDidMount() {
    this.fetchListings();
  }

  fetchListings = () => {
    this.props.fetchTeacherListings();
  }

  handleClickListing = (listingId) => {
    browserHistory.push(`/teacher/schedule/listings/${listingId}`);
  }

  handleAdd = () => {
    browserHistory.push('/teacher/schedule/listings/new');
  }

  render() {
    const { listings } = this.props;

    return (
      <div className="teacher-listing-home full-height card">
        <div className="px-4 px-md-4 px-lg-5 pt-4 pt-md-4 pt-lg-5">
          <h4 className="mb-2 mb-lg-4">Listings</h4>
          <div className="row">
            <button onClick={this.handleAdd} type="button" className="btn btn-secondary btn-cursor">
              Add
            </button>
          </div>
          <div className="row">
            {listings.map((listing, index) => (
              <div key={index} className="col col-12 col-sm-6 col-xl-4">
                <ListingBox listing={listing} onClick={this.handleClickListing} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    listings: state.teacher.listings
  };
}

export default connect(
  mapStateToProps,
  {
    fetchTeacherListings
  }
)(TeacherScheduleListingHome);



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Listings/Home/index.js